import styled from 'styled-components/macro';
import { deviceMin } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { CONTAINERS } from 'utils/baseStyleSizes';

export const MainContainer = styled.div`
  max-width: ${CONTAINERS.container1920};
  min-height: 100%;
  background: ${COLORS.lightGray};
  margin: 0 auto;

  .word {
    position: relative;
    z-index: 4;
    width: 100%;
    margin-top: -304px;

    @media ${deviceMin.mobileS} {
      margin-top: 400px;
    }

    @media ${deviceMin.tablet} {
      margin-top: -180px;
    }

    @media ${deviceMin.laptopL} {
      margin-top: -240px;
    }

    @media ${deviceMin.desktop} {
      margin-top: -304px;
    }
  }

  .familyTravel {
    ${FLEX_CONTAINER.FlexEndRow}
    position: relative;
    z-index: 2;

    @media ${deviceMin.mobileS} {
      ${FLEX_CONTAINER.FlexStartRow}
      margin-bottom: 16px;
      margin-left: 40px;
    }

    @media ${deviceMin.tablet} {
      margin-left: 0;
      margin-top: -40px;
      margin-bottom: 16px;
      justify-content: center;
    }

    @media ${deviceMin.laptopL} {
      margin-top: -75px;
      margin-bottom: 16px;
    }

    @media ${deviceMin.desktop} {
      margin-top: 0;
      margin-bottom: 20px;
    }

    p {
      ${FONT_FAMILY.FontBold}
      margin-left: 32px;
      margin-top: 140px;

      @media ${deviceMin.mobileS} {
        ${FONTS.font16}
        margin-top: 0;
        margin-left: 0;
      }

      @media ${deviceMin.tablet} {
        ${FONTS.font16}
        margin-left: 12px;
      }

      @media ${deviceMin.laptopL} {
        ${FONTS.font20}
        margin-top: 140px;
        margin-left: 32px;
      }

      @media ${deviceMin.desktop} {
        ${FONTS.font24}
      }
    }

    img {
      @media ${deviceMin.mobileS} {
        width: 68px;
        height: 61px;
        display: none;
      }

      @media ${deviceMin.mobileL} {
        width: 68px;
        height: 61px;
        display: block;
      }

      @media ${deviceMin.tablet} {
        width: 99px;
        height: 89px;
      }

      @media ${deviceMin.laptopL} {
        width: 184px;
        height: 166px;
      }

      @media ${deviceMin.desktop} {
        width: 282px;
        height: 255px;
      }
    }
  }

  .loader {
    background: ${COLORS.red};
  }
`;
